import template from './qualifications.html';
import controller from './qualificationsCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    parentToChildNotificationRegistration: '&',
    presetList: '<',
  },
};
